import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Header from '../component/Header';
import SideBar from '../component/SideBar';
import ViewAddOnScreen from '../component/ViewAddOnScreen ';
import Actions from '../redux/actions';
import { addOnListLoader } from '../redux/reducer/AddOnReducer ';
import AppLoader from '../utils/AppLoader';


class AdminViewAddOn extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            viewData: []
        }
    }
    componentDidMount() {
        this.getAddOn()
    }
    getAddOn = () => {
        const route = window.location.href.split('/')
        const isAdmin = route[3] === 'admin' ? true : false
        let params = {
            id: this.props.match.params.id
        }
        const callback = (response) => {
            if (response) {
                this.setState({ viewData: response })
            }
        }
        this.props.getAddOnDetails(params, callback, isAdmin)
    }
    render() {
        const { viewData } = this.state;
        const { isLoading } = this.props;
        return (
            <div className="dashboard-screen-part">
                <div className="d-flex p-0">
                    <SideBar />
                    <div className="card-right p-0">
                        <Header />
                        <ViewAddOnScreen data={viewData} />
                    </div>
                </div>
                {isLoading && <AppLoader />}
            </div>
        )
    }
}

export const mapStateToProps = (state) => {
    return {
        isLoading: addOnListLoader(state)
    }
};

export default withRouter(connect(mapStateToProps, {
    getAddOnDetails: Actions.getAddOnDetails,
})(AdminViewAddOn));